// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1UserAccountPropertySchema = z.object({
  id: z.number().int(),
  user_account_id: z.number().int(),
  account_user_property_id: z.number().int(),
  value: z.coerce.string().min(1).max(50),
});
